import React, { useEffect, useState } from 'react'
import { useWallet } from '../../contexts/WalletContext'
import { getAffiliateCommissionHistory } from '../../services/affiliateService'
import type { AffiliateCommissionHistoryItem } from '../../services/affiliateService'
import {
  formatCommissionHistoryDateTime,
  formatCommissionMemberLabel,
} from '../../utils/affiliateHistoryUtils'

function maskMember(raw: string): string {
  const s = String(raw || '').trim()
  if (!s) return 'สมาชิก'
  if (s.length < 4) return s
  if (/^\d+$/.test(s)) {
    if (s.length >= 10) return s.slice(0, 3) + 'xxxxxx' + s.slice(-1)
    return s.slice(0, 2) + 'xxxxx' + s.slice(-1)
  }
  if (s.length <= 6) return s.slice(0, 1) + 'xxx' + s.slice(-1)
  return s.slice(0, 2) + '****' + s.slice(-3)
}

const AffiliateIncomePage: React.FC = () => {
  const { formatCurrency } = useWallet()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [commissionHistory, setCommissionHistory] = useState<AffiliateCommissionHistoryItem[]>([])

  useEffect(() => {
    let cancelled = false
    async function load() {
      setLoading(true)
      setError(null)
      try {
        const history = await getAffiliateCommissionHistory(100)
        if (!cancelled) {
          setCommissionHistory(history)
        }
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : 'โหลดข้อมูลไม่สำเร็จ')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [])

  if (loading) {
    return (
      <div className="text-center py-3">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-2">กำลังโหลดข้อมูล...</p>
      </div>
    )
  }
  if (error) {
    return (
      <div className="text-center py-3">
        <p className="c-red">{error}</p>
      </div>
    )
  }

  return (
    <div>
      <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
        <i className="far fa-plus-square me-2"></i>
        รายได้
      </div>

      {commissionHistory.length > 0 ? (
        <div className="bdr-5 bgc-4 p-2 mb-2">
          <small className="t-medium">ประวัติคอมมิชชั่น</small>
          <div className="table-responsive w-100 mt-1">
            <table className="table mb-0 table-striped table-bordered text-center table-sm">
              <thead className="table-dark">
                <tr>
                  <th>วันที่ เวลา</th>
                  <th>สมาชิก</th>
                  <th>ยอดเสีย/ยอดแทง</th>
                  <th>คอมมิชชั่น</th>
                </tr>
              </thead>
              <tbody>
                {commissionHistory.map((item, i) => (
                  <tr key={item._id || `${item.createdAt || item.date}-${i}`}>
                    <td>{formatCommissionHistoryDateTime(item)}</td>
                    <td>{formatCommissionMemberLabel(item, maskMember)}</td>
                    <td>{formatCurrency(item.betAmount ?? 0)}</td>
                    <td>{formatCurrency(item.commission ?? 0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="bdr-5 bgc-4 p-2">
          <h5 className="c-red text-center mb-0">ไม่มีประวัติคอมมิชชั่น</h5>
        </div>
      )}
    </div>
  )
}

export default AffiliateIncomePage
